import React from "react";
import {
  Row,
  Col,
  Input,
  Tag,
  Avatar,
  Button,
  Space,
  Dropdown,
  Popconfirm,
  message,
  Tooltip,
  Modal,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext, StoreProvider } from "../store/RootStore";
import { Link } from "react-router-dom";
import ShareModalWindow from "./ShareModalWindow";
import {
  PushpinFilled,
  EditFilled,
  DeleteFilled,
  QuestionCircleOutlined,
  DownOutlined,
  SearchOutlined,
  DownloadOutlined,
  CloudUploadOutlined,
  DashboardOutlined,
  PlusOutlined,
  CarOutlined,
  CopyOutlined,
  ShareAltOutlined,
  FacebookOutlined,
  TwitterOutlined,
  MailOutlined,
  SkypeOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import AddButton from "./AddButton";
import DeleteConfirm from "./DeleteConfirm";
import config from "../config";
import withRouter from "../withRouter";

import AssignRouteStore from "../store/AssignRouteStore";
import CompanyStore from "../store/CompanyStore";
import AssignBusToStudent from "./AssignBusToStudent";
import Icon from "react-multi-date-picker/components/icon";

class AssignRouteList extends React.Component {
  constructor(props) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.companyStore = new CompanyStore(this);
    this.onDelete = this.onDelete.bind(this);

    this.AssignRouteStore = new AssignRouteStore();

    // console.log(this.context);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      companyId: "",
      loadList: 0,
      company_value_label: "",
      openShareModal: false,
    };
    this.menuProps = {
      items: [
        {
          label: "Sample Excel",
          key: "1",
          icon: <DownloadOutlined />,
        },
        {
          label: "Upload",
          key: "2",
          icon: <CloudUploadOutlined />,
        },
        {
          label: "Dashboard",
          key: "2",
          icon: <DashboardOutlined />,
        },
      ],
      onClick: () => {},
    };

 
  }

    formatAddress = (sequenceNo) => {
    if (!sequenceNo) return "";

    // Split only on the first dash
    const firstDashIndex = sequenceNo.indexOf("-");

    if (firstDashIndex === -1) return sequenceNo; // no dash found

    return sequenceNo.substring(firstDashIndex + 1).trim();
  };

  async componentDidMount() {
    this.setState({ pageSize: 50 });

     if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
     
      this.setState(
        { companyId: this.props.getUserData().userCompanyId },
        () => this.handleSearch()  // RUN AFTER STATE UPDATED
      );
    }
    


    const singleData = await this.companyStore.getCompanyDataById(
      this.context.viewStateStore.assignTripObject.companyId
    );
    await this.setState({ loadList: 1 }); //need to reload data
    await this.setState({ company_value_label: singleData });

    this.columns = [
      {
        // title: "Trip Code",
        title: this.context.translate("_FLEET_CREATEROUTE_ROUTEADD_ROUTENAME_"),
        // width: 150,
        dataIndex: "routeName",
        key: "routeName",
        render: (val, record) => {
          return (
            <Link
              onClick={(e) => {
                e.preventDefault();
                this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
        // fixed: "left",
      },
      {
        // title: "Trip Name",
        title: this.context.translate("_START_POINT_"),
        // width: 150,
        dataIndex: "startPoint",
        key: "startPoint",
        // fixed: "left",
        render: (_, record) => {
          try {
            const points = record?.RoutePoints || [];
            if (points.length === 0) return "-";

             const first = points[0];
            const sequence = first.sequenceNo;

            return this.formatAddress(sequence);
          } catch {
            return "-";
          }
        }
      },
      {
        // title: "Zone Details",
        title: this.context.translate("_END_POINT_"),
        // width: 150,
        dataIndex: "endPoint",
        key: "endPoint",
        // fixed: "left",
        render: (_, record) => {
          try {
            const points = record?.RoutePoints || [];
            if (points.length === 0) return "-";

            const last = points[points.length - 1];
            const name = last.sequenceNo;

            return this.formatAddress(name);
          } catch {
            return "-";
          }
        }
      },
      {
        // title: "Vehicle No",
        title: this.context.translate("_TOTAL_STOPS_"),
        // width: 150,
        dataIndex: "totalStops",
        key: "totalStops",
        // fixed: "left",
      },
      {
        // title: "Seater",
        title: this.context.translate("_EST_DISTANCE_"),
        // width: 150,
        dataIndex: "travelDistance",
        key: "travelDistance",
        // fixed: "left",
        render: (_, record) => {
          try {
            const points = record?.RoutePoints || [];
            const last = points[points.length - 1];
            const dist = last.travelDistance;
            if (!dist) return "-";

            // Ext JS: Math.floor(distanceinkm) + " Km"
            return Math.floor(Number(dist)) + " Km";
          } catch {
            return "-";
          }
          // debugger
          // try {
          //   const points = record?.RoutePoints || [];
          //   if (points.length === 0) return "-";

          //   const last = points[points.length - 1];
          //   const km = Math.floor(last.travelDistance / 1000);

          //   return km + " Km";
          // } catch {
          //   return "-";
          // }
        }
      },
      {
        // title: "Available Seats",
        title: this.context.translate("_EST_TIME_"),
        // width: 150,
        dataIndex: "travelDuration",
        key: "travelDuration",
        // fixed: "left",
        render: (_, record) => {
          try {
            const points = record?.RoutePoints || [];
            const last = points[points.length - 1];
            const dur = last?.travelDuration;
            if (!dur) return "-";

            // Already: "1 hour 22 mins"
            return dur;
          } catch {
            return "-";
          }
          // debugger
          // try {
          //   const points = record?.RoutePoints || [];
          //   if (points.length === 0) return "-";

          //   const last = points[points.length - 1];
          //   const duration = last.travelDuration;

          //   const hours = Math.floor(duration / 3600);
          //   const minutes = Math.round((duration % 3600) / 60);

          //   let result = "";
          //   if (hours > 0) result += hours + " hrs ";
          //   if (minutes > 0) result += minutes + " mins";

          //   return result.trim();
          // } catch {
          //   return "-";
          // }
        }
      },
      {
        title: this.context.translate("_ACTION_"),
        dataIndex: "Action",
        // key: "Action",
        fixed: "right",
        // width: 50,
        render: (_, record) => {
          let tripPoints = record.RoutePoints;
          let data = [];
          tripPoints.forEach((val) =>
            data.push(`${val.latitude},${val.longitude}`)
          );

          return (
            <>
              <Space>
                <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      title={this.context.translate("_DELETE_ROUTE_DETAILS_")}
                      color={config.tooltipColorDelete}
                      placement="bottom"
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm>
              </Space>
            </>
          );
        },
      },
    ];
  }
  onEdit = async (record) => {
    console.log(record);
    const routeId = record.routeId;
    //  await this.context.viewStateStore.setAssignRouteStates({
    //    companyId: record.companyId,
    //  });
    if (routeId) {
      this.props.navigate("/assignrouteaddnew/" + routeId);
    }
  };
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    console.log(comp);
    // await this.AssignRouteStore.loadData(comp.value)
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    console.log(singleData);
    await this.setState({ company_value_label: singleData });

    await this.setState({ loadList: 1 });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.AssignRouteStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId
    });
    await this.setState({ loadList: 1 });
  }
  async onDelete(record) {

    console.log(record);
    const response = await this.AssignRouteStore.deleteRoute({
      stId: record.routeId,
    });
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }
 


  render() {
    console.log("in render");
    return (
      <>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_FLEET_DASHBORD_NAVIRIGHT_ROUTE_")}
                {/* Create/Assign Trip Details */}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  placement="left"
                  title="Add"
                  color={config.primaryColor}
                >
                  {/* <AddButton
                    type="primary"
                    className="addButton"
                    icon={<PlusOutlined />}
                    link="/assigntripadd"
                  /> */}

                  <Button
                    className="addButton"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() => this.props.navigate("/assignrouteaddnew")}
                  ></Button>
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </div>

        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          {/* <div style={{padding:"24px"}}> */}
          {/* <div className='heading'>Create/Assign Trip Details</div> */}
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : ""
                  }
                  // allowClear={true}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            {/* <Col span={8}>
                  <Space style={{float:this.context.locale.direction=="ltr"?"right":"left"}}> 
                    <AddButton title={this.context.translate('_ADD_')} link ="/assigntripaddnew" />
                    
                  </Space>
                </Col> */}
          </Row>

          <ListTable
            current={this.state.currentPage}
            total={this.AssignRouteStore?.total}
            columns={this.columns}
            dataSource={this.AssignRouteStore?.routeDataArray}
            loading={this.AssignRouteStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openShareModal && (
          <ShareModalWindow
            shareLink={this.state.openShareModal}
            shareModalCloseFunc={(resp) =>
              this.setState({ openShareModal: resp })
            }
            shareModalVisible={this.state.openShareModal}
          />
        )}
      </>
    );
  }
}
AssignRouteList.contextType = StoreContext;
export default observer(withRouter(AssignRouteList));

//
